module.exports = __webpack_public_path__ + "img/quotas-ended.8e0fc208.svg";